module.exports = "pegasus/assets/blocks/image-1-tech.png";